const Vue = require('vue')
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'

import zhLocale from './zh'
import enLocale from './en'
const iwaysUiZhLocale = global.IwaysUi.lang.zhCN
const iwaysUiEnLocale = global.IwaysUi.lang.en
const IwaysUI = require('IwaysUi')

Vue.use(VueI18n)

const messages = {
  'zh_CN': {
    ...zhLocale,
    ...iwaysUiZhLocale

  },
  'en': {
    ...enLocale,
    ...iwaysUiEnLocale

  }
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh_CN | es
  locale: Cookies.get('language') || 'zh_CN',
  // set locale messages
  messages
})
IwaysUI.i18n((key, value) => i18n.t(key, value))

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js